import React, { useEffect, useState } from 'react';
import { Badge } from '../ui/badge';
import { tasksApi } from '../../lib/tasks';

export const TaskCount: React.FC<{ personHistoryId: number }> = ({ personHistoryId }) => {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let mounted = true;
    tasksApi
      .list({ personHistoryId, status: 'all' })
      .then(list => { if (mounted) setCount(list.length); })
      .catch(() => { if (mounted) setCount(0); });
    return () => { mounted = false; };
  }, [personHistoryId]);

  if (count === null) {
    return <Badge variant="outline" className="text-xs">Aufgaben …</Badge>;
  }

  if (count === 0) {
    return <Badge variant="outline" className="text-xs">0 Aufgaben</Badge>;
  }

  return (
    <Badge variant="outline" className="text-xs bg-blue-50 text-blue-700 border-blue-200">Aufgaben: {count}</Badge>
  );
};

export default TaskCount;


